module.exports = __webpack_public_path__ + "public/img/gongxu_1.4af131d7.png";